<template>
    <div class="app">
        <div class="app-header dark">
           <div class="header-left">
              <div class="header-logo">
                  <div class="logo-icon">
                    <i class="el-icon-chat-line-square"></i>
                  </div>
                  <h3 class="logo-name">AI管理系统</h3>
                  <h5 class="logo-subname">{{nodeName}}</h5>
              </div>
              <el-menu :default-active="headerMenuCur" class="header-menu" mode="horizontal">
                <el-menu-item v-for="(item,key) in headerMenus" :key="key" :index="item.path" @click="handleClick(item.path)">
                    {{item.meta.title}}
                </el-menu-item>
              </el-menu>
           </div>
           <RightMenu :menu=false />
        </div>
        <div class="app-aside" v-if="secondMenus.length > 0">
            <el-menu :default-active="secondMenuCur" class="app-menu" background-color="#00000000">
              <SubMenu :subMenuList="secondMenus"  mode="vertical"/>
            </el-menu>
        </div>
        <div class="app-content">
            <router-view />
        </div>
    </div>
</template>
<script>
  import SubMenu from '@/components/SubMenu'
  import RightMenu from '@/components/RightMenu'
  import config from '@/utils/config';
  import {getUserInfo,deleteKey,getNodeName} from '@/utils/store';
  export default {
    components: {
      SubMenu,RightMenu
    },
    data() {
      return {
        headerMenus:[],
        secondMenus:[],
        secondMenuCur:'',
        headerMenuCur:'',
        headerTitle:'',
        userInfo:[],
        nodeName:""
      };
    },
    mounted(){
        this.userInfo = getUserInfo()
        this.init()
    },
    watch: {
    '$route' (to, from) {
      this.initMenu()
    },
    'headerMenuCur'(val){
       console.log(val);
       if(val != this.headerMenuCur && val != this.$route.path){
          this.$router.push({path:val})
       }
    }
  },
    methods: {
      init(){
        let options =  this.$router.options.routes[0];
        this.nodeName = getNodeName();
        this.headerMenus = options.children.filter(item=>{
             //console.log(item.meta.auth)
             //console.log(this.userInfo)
             console.log(item.meta.node)
                  console.log(config.isMain)
             if(item.meta.node=="main" && config.isMain == false){
               return false
             }
             if(item.meta.auth.includes(this.userInfo.role)){
              return true
             }
             
             return false
        });
        this.initMenu();
      },
      initMenu(){
        let curPath = this.$route.matched;
        console.log(this.headerMenus)
        let len = curPath.length;
        if(len > 1){
          this.headerMenuCur = curPath[1].path;
          console.log(this.headerMenuCur)
        }
        this.headerMenus.forEach(element => {
          if(this.$route.path.indexOf(element.path) > -1){
            if(element.children){
              this.secondMenus = element.children
              this.secondMenuCur = this.$route.path
            }else{
              this.secondMenus = [];
            }
            this.headerTitle = element.title
          }
        });
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClick(path){
        console.log(path);
        if(path != this.$route.path){
          path = path.replace(":appId",this.appId);
          this.$router.push({path:path})
       }
      },
      logout(){
         deleteKey("token")
         deleteKey("UserInfo")
         this.userInfo =  null
         this.$router.push({path:"/login"});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MainLayout.vue